import validate from "/buddy/openesg-app/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  guest: () => import("/buddy/openesg-app/apps/frontend/middleware/guest.ts"),
  public: () => import("/buddy/openesg-app/apps/frontend/middleware/public.ts"),
  unsubscribed: () => import("/buddy/openesg-app/apps/frontend/middleware/unsubscribed.ts")
}